import { Loader } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { isNil } from 'lodash';
import React from 'react';
import Pluralize from 'react-pluralize';

import { SEARCH_RESULT_SORT_OPTIONS } from '../SearchResults.constants';
import styles from './SearchResultsHeader.module.scss';
import SortSelect from '../SortSelect';
import { SortOption } from '../../../services/services.constants';

interface SearchResultsHeaderProps {
  searchTerm: string;
  activeSortOption: SortOption;
  resultsCount?: number;
  onSortOptionSelect: (value: SortOption) => void;
}

const cx = classNames.bind(styles);

const SearchResultsHeader = ({
  searchTerm,
  resultsCount,
  activeSortOption,
  onSortOptionSelect,
}: SearchResultsHeaderProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      <div className={cx('results-header')}>
        <div className={cx('results-header-heading')}>
          <h2 className={cx('header')} data-testid="search-result-header">
            <>
              <span className={cx('results-prefix')}>Results&nbsp;for&nbsp;</span>
              {searchTerm || 'selected tags'}
              <span className={cx('results-count')}>
                {isNil(resultsCount) ? (
                  <Loader color="tertiary" text={null} />
                ) : (
                  resultsCount > 0 && <Pluralize count={resultsCount} singular="Result" plural="Results" />
                )}
              </span>
            </>
          </h2>
        </div>

        <div className={cx('sort-section')}>
          <span className={cx('sort-heading')}>Sort by:</span>
          <SortSelect
            options={SEARCH_RESULT_SORT_OPTIONS}
            selectedOption={activeSortOption}
            onOptionSelect={onSortOptionSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchResultsHeader;
